<template>
  <div class="alert alert-info user-filter-1 ">

    <div class="sticky-top py-2  w-100" style="background-color: #f0f0f0;">
      <div class="">
      <span class="badge badge-primary m-1" v-for="(item,index) in selectedUsers"
            @click="removeItem(index)"
      >
      {{ item.name }} {{ item.last_name }}
    </span>
      </div>

      <div class="col-12 p-0 m-0">
        <form @submit.prevent="submit">
          <div class="row mt-2 justify-content-center">
            <b-form-input
                class="col-8"
                v-model="searchWords"
                placeholder="جستجو"
            ></b-form-input>
            <button class="btn col-3 mr-1   btn-primary">جستجو</button>
          </div>
        </form>
      </div>
    </div>

    <div class="" v-for="user in users ">

      <div class="form-check">
        <label @click="addItem(user)" class="form-check-label my-2 mr-3" :for="`user_${user.id}`">
          {{ user.name }} {{ user.last_name }}
        </label>
      </div>

    </div>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "UserFilter1",
  props: {
    usersProp: {
      default: null
    },
    roles: {
      default: null,
    }
  },
  data() {
    return {
      users: [],
      searchWords: '',
      selectedUsers: []
    }
  },
  methods: {
    async getUsers() {
      if (this.roles != null) {
        this.$store.commit("User/setFilters", {key: "role", value: this.roles});
      }
      let data = await this.$store.dispatch('User/getPersonsWithoutState', 1)
      data = data.data.data;
      this.users = data.data
    },
    submit() {
      this.$store.commit('User/setFilters', {key: 'search', value: this.searchWords})
      this.getUsers()
    },
    addItem(item) {
      let ids = this.selectedUsers.map(item => item.id)
      if (ids.indexOf(item.id) === -1) {
        this.selectedUsers.push(item)
      } else {
        toast('ایتم وجود دارد', 'ایتم وجود دارد', 'danger')
      }
      this.$emit('selected_users', this.selectedUsers)
    },
    removeItem(index) {
      this.selectedUsers.splice(index, 1)
      this.$emit('selected_users', this.selectedUsers)
    }
  },
  mounted() {
    this.getUsers();
  },
  watch: {
    selectedUsers: {
      handler(oldValue, newValue) {
        let usersId = this.selectedUsers.map(item => {
          return item.id
        })
        this.$emit('updateFilter', {users: usersId, usersObject: this.selectedUsers})
      }
    },
    usersProp: {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.selectedUsers = this.usersProp
        }
      },
      deep: true
    }
  },
}
</script>


<style scoped>
.user-filter-1 {
  height: 300px !important;
  overflow-y: auto;
}
</style>